import * as yup from 'yup';

export const adminValidationSchema = yup.object().shape({
  email: yup
    .string()
    .email('*Please follow the format: example@email.com')
    .required('*is required')
    .max(255)
    .label('email'),
  firstName: yup
    .string()
    .trim()
    .min(1, 'First name is required')
    .max(35)
    .matches(/^[A-Za-z][A-Za-z ]*$/gi, '*Please provide the name using Latin letters')
    .required('*is required'),
  lastName: yup
    .string()
    .trim()
    .min(1, 'Last name is required')
    .max(35)
    .matches(/^[A-Za-z][A-Za-z ]*$/gi, '*Please provide the name using Latin letters')
    .required('*is required'),
});
